import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppActions } from './app/app.actions';
import { RootStoreActions } from './root-store.actions';

@Injectable()
export class RootStoreEffects {
  private actions$ = inject(Actions);

  changeAssetLoadInitDataEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(RootStoreActions.ChangeAsset),
      map(() => AppActions.TriggerAppInit())
    )
  );
}
